import { useTranslation } from "react-i18next";

import Chip from "components/Chip";
import { getStatusColor } from "components/StatusBadge";

import { Props } from "./typings";
import styles from "./styles.module.scss";

// Pomarańczowa flaga z palety statusów (StatusBadge) — bez lokalnych kolorów.
const FLAG_ORANGE = 5;

// Plakietka „Nowsze dane adresata”: przesyłka trzyma starszą wersję podmiotu niż bieżąca
// w książce adresowej. Dane przenosi akcja „Aktualizuj dane adresata”.
const ReceiverDataOutdatedBadge = ({ hint }: Props) => {
  const { t } = useTranslation();

  return (
    <span className={styles.badge} title={hint ?? t("receiverData.outdatedHint")}>
      <Chip
        small
        background={getStatusColor(FLAG_ORANGE) + "3a"}
        color="var(--Nota-sys-light-on-surface, #1c1b1f)"
        element={<>{t("receiverData.outdated")}</>}
      />
    </span>
  );
};

export default ReceiverDataOutdatedBadge;
